import { useState } from 'react';

export default function IndustriesSection() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const industries = [
    {
      title: 'Health & Wellness',
      description: 'A.I. scheduling + follow-ups for higher patient retention and automated appointment management.',
      image: 'https://public.readdy.ai/ai/img_res/95cca96049439bb122f333d94ab36767.jpg',
      stats: '40% increase in patient retention'
    },
    {
      title: 'Healthcare Staffing',
      description: 'Instant quote bots + automated job booking that converts leads into scheduled appointments 24/7.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20healthcare%20staffing%20agency%20office%20with%20medical%20professionals%2C%20nurses%20and%20doctors%20in%20modern%20healthcare%20recruitment%20environment%2C%20medical%20staffing%20coordination%20center%2C%20healthcare%20workforce%20management%20systems%2C%20clean%20professional%20medical%20staffing%20workspace&width=500&height=400&seq=healthcare-staffing&orientation=landscape',
      stats: '60% faster quote delivery'
    },
    {
      title: 'Managed Service Providers',
      description: 'A.I. onboarding + compliance documentation automation for streamlined client acquisition.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20financial%20services%20office%20with%20AI%20compliance%20systems%2C%20professional%20banking%20environment%20with%20automated%20documentation%20tools%2C%20fintech%20workspace%20with%20digital%20onboarding%20interface%2C%20clean%20financial%20consulting%20setup%2C%20regulatory%20technology%20systems&width=500&height=400&seq=finance&orientation=landscape',
      stats: '75% reduction in onboarding time'
    },
    {
      title: 'Professional Services',
      description: 'HR + client communication automation that scales your practice without adding overhead.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20services%20office%20with%20automated%20HR%20systems%2C%20modern%20consulting%20workspace%20with%20client%20management%20tools%2C%20business%20automation%20environment%2C%20professional%20meeting%20room%20with%20digital%20communication%20systems%2C%20clean%20corporate%20design&width=500&height=400&seq=professional&orientation=landscape',
      stats: '50% improvement in client satisfaction'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Industries We Serve
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tailored A.I. solutions designed for the unique challenges and opportunities in your industry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {industries.map((industry, index) => (
            <div 
              key={index}
              className="relative group cursor-pointer rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="aspect-[4/3] relative">
                <img 
                  src={industry.image}
                  alt={industry.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                
                <div className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-opacity duration-300 ${
                  hoveredIndex === index ? 'opacity-90' : 'opacity-60'
                }`}></div>
                
                <div className="absolute inset-0 p-8 flex flex-col justify-end text-white">
                  <div className={`transform transition-all duration-300 ${
                    hoveredIndex === index ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
                  }`}>
                    <div className="text-sm font-medium text-blue-300 mb-2">
                      {industry.stats}
                    </div>
                  </div>
                  
                  <h3 className="text-2xl font-bold mb-3">
                    {industry.title}
                  </h3>
                  
                  <p className={`text-gray-200 leading-relaxed transition-all duration-300 ${
                    hoveredIndex === index ? 'opacity-100 max-h-32' : 'opacity-80 max-h-20'
                  } overflow-hidden`}>
                    {industry.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
